"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorsProcessAvailableItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const ProcessesAndAssessments_1 = require("../../enm/ProcessesAndAssessments");
exports.DistributorsProcessAvailableItem = {
    priority: 1,
    label: 'fields.enm.processes_and_assessments.label',
    fallbackLabel: 'Does your company have any of the below processes for your distributors? Please check all that apply.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.entrust_other_contracted_entities', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: ProcessesAndAssessments_1.ProcessesAndAssessmentsRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
